import { jsx, jsxs } from "react/jsx-runtime";
function SuccessIcon() {
    return /*#__PURE__*/ jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 64 64",
        fill: "none",
        children: [
            /*#__PURE__*/ jsx("path", {
                d: "M32.0001 58.6666C39.3638 58.6666 46.0305 55.6818 50.8562 50.8561C55.6819 46.0303 58.6667 39.3637 58.6667 31.9999C58.6667 24.6362 55.6819 17.9695 50.8562 13.1437C46.0305 8.31802 39.3638 5.33325 32.0001 5.33325C24.6363 5.33325 17.9697 8.31802 13.1439 13.1437C8.31818 17.9695 5.3334 24.6362 5.3334 31.9999C5.3334 39.3637 8.31818 46.0303 13.1439 50.8561C17.9697 55.6818 24.6363 58.6666 32.0001 58.6666Z",
                fill: "currentColor",
                stroke: "currentColor",
                strokeWidth: "5.33333",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M21.6667 32.4444L29.1112 39.8888L44 25",
                stroke: "white",
                strokeWidth: "4.26667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}
export { SuccessIcon as default };
